import { render, staticRenderFns } from "./FinanceTab.vue?vue&type=template&id=236be91b&scoped=true"
import script from "./FinanceTab.vue?vue&type=script&lang=js"
export * from "./FinanceTab.vue?vue&type=script&lang=js"
import style0 from "./FinanceTab.vue?vue&type=style&index=0&id=236be91b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236be91b",
  null
  
)

export default component.exports